<script setup lang="ts">
  import { ButtonQC } from '@qicgroupdoha/qic-connect-ds'

  interface Emits {
    (e: 'cancel'): void
    (e: 'delete'): void
  }

  const emit = defineEmits<Emits>()
</script>

<template>
  <div class="remove-window">
    <p class="heading-6">{{ $t('qlm_delete_pers') }}</p>
    <div class="remove-window__wrapper">
      <ButtonQC
        variant="primary"
        size="medium"
        data-test="cancel-remove-user-button"
        @click="emit('cancel')"
        >{{ $t('qlm_cancel') }}</ButtonQC
      >
      <ButtonQC
        variant="outline"
        size="medium"
        data-test="accept-remove-user-button"
        @click="emit('delete')"
        >{{ $t('qlm_delete') }}</ButtonQC
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .remove-window {
    display: flex;
    flex-direction: column;
    gap: 19px;
    padding: var(--spacing-7);
    border-radius: var(--radius-6);
    width: 100%;
    background: var(--colorBgSrfSecondary);
    text-align: center;
    color: var(--colorBgSrfContrastDark);

    &__wrapper {
      display: flex;
      gap: 16px;
      align-items: center;
      justify-content: stretch;

      & > button {
        flex: 1;
      }
    }
  }
</style>
